import { STEPS } from "@/lib/data";

export default function HowItWorks() {
  return (
    <section id="processus" data-testid="how-it-works-section" className="section-y bg-accent/30">
      <div className="container-x">
        <div className="max-w-2xl mb-14">
          <p className="overline mb-3">Comment ça fonctionne</p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-secondary tracking-tight">
            Simple. Rapide. Efficace.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${i}`}
              className="relative p-8 rounded-2xl bg-white border border-gray-100 hover:border-primary/30 hover:-translate-y-1 transition-all duration-300"
            >
              <span className="absolute -top-4 right-6 text-6xl font-bold text-primary/10 select-none">
                {s.n}
              </span>
              <div className="w-10 h-10 rounded-xl bg-primary text-white grid place-items-center font-semibold mb-4">
                {i + 1}
              </div>
              <h3 className="text-lg font-semibold text-secondary mb-2">{s.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
